import {environment} from "../../../../environments/environment";

export const DefaultPlanningBlockColumnDefinition: any[] =
  [
    // 'COLUMN_SELECTION.COLUMN_NAMES.containerStatus',
    // 'COLUMN_SELECTION.COLUMN_NAMES.containerOrTrailerType',
    // 'COLUMN_SELECTION.COLUMN_NAMES.containerNo',
    // 'COLUMN_SELECTION.COLUMN_NAMES.orderNumber',
    // 'COLUMN_SELECTION.COLUMN_NAMES.depotOutFrom',
    // 'COLUMN_SELECTION.COLUMN_NAMES.vgmClosing',
    // 'COLUMN_SELECTION.COLUMN_NAMES.fileId',
  ].map((x) => {
    return {
      name: x,
      width: 200,
    };
  });

export const RailwayColumnDefinition: any[] = [
  "COLUMN_SELECTION.COLUMN_NAMES.shuttle",
  "COLUMN_SELECTION.COLUMN_NAMES.railwayCompanyName",
  "COLUMN_SELECTION.COLUMN_NAMES.railwayLineName",
  "COLUMN_SELECTION.COLUMN_NAMES.railwayScheduledArrival",
  "COLUMN_SELECTION.COLUMN_NAMES.railwayScheduledDeparture",
  "COLUMN_SELECTION.COLUMN_NAMES.railEarliestPickupTime",
  "COLUMN_SELECTION.COLUMN_NAMES.railScheduledClosing"
];

export const RailwayOrShippingColumnDefinition: any[] = [
  "COLUMN_SELECTION.COLUMN_NAMES.nextTransportMode",
  "COLUMN_SELECTION.COLUMN_NAMES.nextTransportModeType",
  "COLUMN_SELECTION.COLUMN_NAMES.nextSupplierCompanyNo",
  "COLUMN_SELECTION.COLUMN_NAMES.nextSupplierCompanyName",
  "COLUMN_SELECTION.COLUMN_NAMES.nextSupplierLineNo",
  "COLUMN_SELECTION.COLUMN_NAMES.nextSupplierLineName",
  "COLUMN_SELECTION.COLUMN_NAMES.nextSupplierLineDescription",
  "COLUMN_SELECTION.COLUMN_NAMES.nextTransportLineStatus",
  "COLUMN_SELECTION.COLUMN_NAMES.nextScheduledDeparture",
  "COLUMN_SELECTION.COLUMN_NAMES.nextScheduledClosing",
  "COLUMN_SELECTION.COLUMN_NAMES.nextScheduledArrival",
  "COLUMN_SELECTION.COLUMN_NAMES.nextEarliestPickupTime",
  "COLUMN_SELECTION.COLUMN_NAMES.prevTransportMode",
  "COLUMN_SELECTION.COLUMN_NAMES.prevTransportModeType",
  "COLUMN_SELECTION.COLUMN_NAMES.prevSupplierCompanyNo",
  "COLUMN_SELECTION.COLUMN_NAMES.prevSupplierCompanyName",
  "COLUMN_SELECTION.COLUMN_NAMES.prevSupplierLineNo",
  "COLUMN_SELECTION.COLUMN_NAMES.prevSupplierLineName",
  "COLUMN_SELECTION.COLUMN_NAMES.prevSupplierLineDescription",
  "COLUMN_SELECTION.COLUMN_NAMES.prevShippingLineStatus",
  "COLUMN_SELECTION.COLUMN_NAMES.prevScheduledDeparture",
  "COLUMN_SELECTION.COLUMN_NAMES.prevScheduledClosing",
  "COLUMN_SELECTION.COLUMN_NAMES.prevScheduledArrival",
  "COLUMN_SELECTION.COLUMN_NAMES.prevEarliestPickupTime"
];

export const OptionalPlanningBlockColumnDefinition: any[] =
  [
    "COLUMN_SELECTION.COLUMN_NAMES.id",
    "COLUMN_SELECTION.COLUMN_NAMES.info",
    "COLUMN_SELECTION.COLUMN_NAMES.planningGroup",
    "COLUMN_SELECTION.COLUMN_NAMES.startFrom",
    "COLUMN_SELECTION.COLUMN_NAMES.startUntil",
    "COLUMN_SELECTION.COLUMN_NAMES.endFrom",
    "COLUMN_SELECTION.COLUMN_NAMES.endUntil",
    "COLUMN_SELECTION.COLUMN_NAMES.trailerNo",
    "COLUMN_SELECTION.COLUMN_NAMES.trailerDescription",
    "COLUMN_SELECTION.COLUMN_NAMES.chassisNo",
    "COLUMN_SELECTION.COLUMN_NAMES.chassisDescription",
    "COLUMN_SELECTION.COLUMN_NAMES.transportOrderNumber",
    "COLUMN_SELECTION.COLUMN_NAMES.customerName",
    "COLUMN_SELECTION.COLUMN_NAMES.customerSearchName",
    "COLUMN_SELECTION.COLUMN_NAMES.reference1",
    "COLUMN_SELECTION.COLUMN_NAMES.truckId",
    "COLUMN_SELECTION.COLUMN_NAMES.customerId",
    "COLUMN_SELECTION.COLUMN_NAMES.firstAction",
    "COLUMN_SELECTION.COLUMN_NAMES.cleaningInstruction",
    "COLUMN_SELECTION.COLUMN_NAMES.requiredLoadingMeters",
    "COLUMN_SELECTION.COLUMN_NAMES.requiredPalletPlaces",
    "COLUMN_SELECTION.COLUMN_NAMES.transportType",
    "COLUMN_SELECTION.COLUMN_NAMES.orderDescription",
    "COLUMN_SELECTION.COLUMN_NAMES.orderDescription2",
    "COLUMN_SELECTION.COLUMN_NAMES.reference2",
    "COLUMN_SELECTION.COLUMN_NAMES.reference3",
    "COLUMN_SELECTION.COLUMN_NAMES.firstPlanAddressSearchName",
    "COLUMN_SELECTION.COLUMN_NAMES.lastPlanAddressSearchName",
    "COLUMN_SELECTION.COLUMN_NAMES.driverFullName",
    "COLUMN_SELECTION.COLUMN_NAMES.driverShortName",
    "COLUMN_SELECTION.COLUMN_NAMES.truck",
    "COLUMN_SELECTION.COLUMN_NAMES.goodsDescription",
    "COLUMN_SELECTION.COLUMN_NAMES.dangerousGoods",
    "COLUMN_SELECTION.COLUMN_NAMES.t1Document",
    "COLUMN_SELECTION.COLUMN_NAMES.revenue",
    "COLUMN_SELECTION.COLUMN_NAMES.cost",
    "COLUMN_SELECTION.COLUMN_NAMES.closingDate",
    "COLUMN_SELECTION.COLUMN_NAMES.firstPlanAction",
    "COLUMN_SELECTION.COLUMN_NAMES.firstPlanCity",
    "COLUMN_SELECTION.COLUMN_NAMES.firstPlanPostalCode",
    "COLUMN_SELECTION.COLUMN_NAMES.lastPlanAction",
    "COLUMN_SELECTION.COLUMN_NAMES.lastPlanCity",
    "COLUMN_SELECTION.COLUMN_NAMES.lastPlanPostalCode",
    "COLUMN_SELECTION.COLUMN_NAMES.operationalStatus",
    "COLUMN_SELECTION.COLUMN_NAMES.totalGrossWeight",
    "COLUMN_SELECTION.COLUMN_NAMES.exportVesselName",
    "COLUMN_SELECTION.COLUMN_NAMES.importVesselName",
    "COLUMN_SELECTION.COLUMN_NAMES.carrierId",
    "COLUMN_SELECTION.COLUMN_NAMES.sealId",
    "COLUMN_SELECTION.COLUMN_NAMES.latestLocationCode",
    "COLUMN_SELECTION.COLUMN_NAMES.depotInFrom",
    "COLUMN_SELECTION.COLUMN_NAMES.actualDepotOut",
    "COLUMN_SELECTION.COLUMN_NAMES.actualDepotIn",
    "COLUMN_SELECTION.COLUMN_NAMES.notifications",
    "COLUMN_SELECTION.COLUMN_NAMES.firstCollectionAddressSearchName",
    "COLUMN_SELECTION.COLUMN_NAMES.firstCollectionCity",
    "COLUMN_SELECTION.COLUMN_NAMES.firstCollectionCountry",
    "COLUMN_SELECTION.COLUMN_NAMES.firstCollectionReference1",
    "COLUMN_SELECTION.COLUMN_NAMES.distanceToCollection",
    "COLUMN_SELECTION.COLUMN_NAMES.firstCollectionRegion",
    "COLUMN_SELECTION.COLUMN_NAMES.firstCollectionPostalCode",
    "COLUMN_SELECTION.COLUMN_NAMES.firstDeliveryAddressSearchName",
    "COLUMN_SELECTION.COLUMN_NAMES.firstDeliveryCity",
    "COLUMN_SELECTION.COLUMN_NAMES.firstDeliveryCountry",
    "COLUMN_SELECTION.COLUMN_NAMES.firstDeliveryReference1",
    "COLUMN_SELECTION.COLUMN_NAMES.distanceToDelivery",
    "COLUMN_SELECTION.COLUMN_NAMES.firstDeliveryRegion",
    "COLUMN_SELECTION.COLUMN_NAMES.firstDeliveryPostalCode",
    "COLUMN_SELECTION.COLUMN_NAMES.firstCollectionFrom",
    "COLUMN_SELECTION.COLUMN_NAMES.firstCollectionUntil",
    "COLUMN_SELECTION.COLUMN_NAMES.firstDeliveryFrom",
    "COLUMN_SELECTION.COLUMN_NAMES.firstDeliveryUntil",
    "COLUMN_SELECTION.COLUMN_NAMES.firstColDelFrom",
    "COLUMN_SELECTION.COLUMN_NAMES.firstColDelUntil",
    "COLUMN_SELECTION.COLUMN_NAMES.tripType",
    "COLUMN_SELECTION.COLUMN_NAMES.endDate",
    "COLUMN_SELECTION.COLUMN_NAMES.haulierRemark",
    "COLUMN_SELECTION.COLUMN_NAMES.planningRemark",
    "COLUMN_SELECTION.COLUMN_NAMES.planningOrderlines",
    "COLUMN_SELECTION.COLUMN_NAMES.tractionOrder",
    "COLUMN_SELECTION.COLUMN_NAMES.firstPlanningTimeFromPlanning",
    "COLUMN_SELECTION.COLUMN_NAMES.firstPlanningTimeUntilPlanning",
    "COLUMN_SELECTION.COLUMN_NAMES.lastPlanningTimeFromPlanning",
    "COLUMN_SELECTION.COLUMN_NAMES.lastPlanningTimeUntilPlanning",
    "COLUMN_SELECTION.COLUMN_NAMES.temperature",
    "COLUMN_SELECTION.COLUMN_NAMES.cargoSumary",
    "COLUMN_SELECTION.COLUMN_NAMES.depotOutOrderLineRef1",
    "COLUMN_SELECTION.COLUMN_NAMES.depotOutOrderLineRef2",
    "COLUMN_SELECTION.COLUMN_NAMES.depotInOrderLineRef2",
    "COLUMN_SELECTION.COLUMN_NAMES.depotInOrderLineRef1",
    "COLUMN_SELECTION.COLUMN_NAMES.bookedDatetimeFrom",
    "COLUMN_SELECTION.COLUMN_NAMES.bookedDatetimeUntil",
    "COLUMN_SELECTION.COLUMN_NAMES.warehouseRemark",
    "COLUMN_SELECTION.COLUMN_NAMES.actualWeight",
    "COLUMN_SELECTION.COLUMN_NAMES.haulierNo",
    "COLUMN_SELECTION.COLUMN_NAMES.haulierName",
    "COLUMN_SELECTION.COLUMN_NAMES.firstCollectionMasterRegion",
    "COLUMN_SELECTION.COLUMN_NAMES.firstCollectionMasterRegionCode",
    "COLUMN_SELECTION.COLUMN_NAMES.firstDeliveryMasterRegion",
    "COLUMN_SELECTION.COLUMN_NAMES.firstDeliveryMasterRegionCode",
    "COLUMN_SELECTION.COLUMN_NAMES.trailerType",
    "COLUMN_SELECTION.COLUMN_NAMES.trailerSubType",
    "COLUMN_SELECTION.COLUMN_NAMES.truckType",
    "COLUMN_SELECTION.COLUMN_NAMES.truckSubType",
    "COLUMN_SELECTION.COLUMN_NAMES.emptyDistance",
    "COLUMN_SELECTION.COLUMN_NAMES.orderDate",
    "COLUMN_SELECTION.COLUMN_NAMES.toFinalizedCombi",
    "COLUMN_SELECTION.COLUMN_NAMES.truckDepartmentCode",
    "COLUMN_SELECTION.COLUMN_NAMES.truckDepartmentDescription",
    "COLUMN_SELECTION.COLUMN_NAMES.status",
    "COLUMN_SELECTION.COLUMN_NAMES.containerStatus",
    "COLUMN_SELECTION.COLUMN_NAMES.containerType",
    "COLUMN_SELECTION.COLUMN_NAMES.containerSubType",
    "COLUMN_SELECTION.COLUMN_NAMES.containerNo",
    "COLUMN_SELECTION.COLUMN_NAMES.orderNumber",
    "COLUMN_SELECTION.COLUMN_NAMES.depotOutFrom",
    "COLUMN_SELECTION.COLUMN_NAMES.vgmClosing",
    "COLUMN_SELECTION.COLUMN_NAMES.fileId",
    "COLUMN_SELECTION.COLUMN_NAMES.etaFrom",
    "COLUMN_SELECTION.COLUMN_NAMES.etaLocation",
    "COLUMN_SELECTION.COLUMN_NAMES.colDelPlanning",
    "COLUMN_SELECTION.COLUMN_NAMES.firstColAddressStreet",
    "COLUMN_SELECTION.COLUMN_NAMES.firstDelAddressStreet",
    "COLUMN_SELECTION.COLUMN_NAMES.firstCollectionRef2",
    "COLUMN_SELECTION.COLUMN_NAMES.firstDeliveryRef2",
    "COLUMN_SELECTION.COLUMN_NAMES.dOutPreAnnouncementNo",
    "COLUMN_SELECTION.COLUMN_NAMES.dOutTruckAppointmentNo",
    "COLUMN_SELECTION.COLUMN_NAMES.dOutTruckAppointmentSystem",
    "COLUMN_SELECTION.COLUMN_NAMES.dInPreAnnouncementNo",
    "COLUMN_SELECTION.COLUMN_NAMES.dInTruckAppointmentNo",
    "COLUMN_SELECTION.COLUMN_NAMES.dInTruckAppointmentSystem",
    "COLUMN_SELECTION.COLUMN_NAMES.tracingNo1",
    "COLUMN_SELECTION.COLUMN_NAMES.tracingNo2",
    "COLUMN_SELECTION.COLUMN_NAMES.goodsTypeSubType",
    "COLUMN_SELECTION.COLUMN_NAMES.office"
  ].concat((environment.railway) ? RailwayColumnDefinition : [])
    .concat((environment.railway || environment.shipping) ? RailwayOrShippingColumnDefinition : []).map((x) => {
    return {
      name: x,
      width: 200,
    };
  });

export const PlanningBlockColumnDefinition: any[] =
  [...DefaultPlanningBlockColumnDefinition, ...OptionalPlanningBlockColumnDefinition];


export const PlanningBlockDockColumnDefinition: any[] =
  PlanningBlockColumnDefinition.filter(
    el => el.name !== "COLUMN_SELECTION.COLUMN_NAMES.status"
       && el.name !== "COLUMN_SELECTION.COLUMN_NAMES.planningOrderlines"
  );


